import type { ReactNode } from "react";
import { Side } from "../destinations/Side";
import { ExtendedLink } from "./ExtendedLink";

export const listVoyagesCulturels = [
  {
    title: "Circuits",
    href: "/themes/circuits-culturels/",
  },
  {
    title: "Séjours",
    href: "/themes/sejours-culturels/",
  },
  {
    title: "Croisières",
    href: "/themes/croisieres-culturelles/",
  },
  {
    title: "Randonnées",
    href: "/themes/sentiers-des-arts/",
  },
  {
    title: "Voyages en famille",
    href: "/themes/voyages-culturels-en-famille/",
  },
  {
    title: "Tempo, rythme modéré",
    href: "/themes/tempo-rythme-modere/",
  },
  {
    title: "Journées",
    href: "/themes/journees-culturelles/",
  },
  {
    title: "Collection Hémérys",
    href: "/themes/haut-de-gamme/",
  },
];

export const listThemes = [
  {
    title: "Musique",
    href: "/themes/voyages-et-festivals-musicaux/",
  },
  {
    title: "Art des jardins",
    href: "/themes/art-des-jardins/",
  },
  {
    title: "Expositions",
    href: "/themes/grandes-expositions/",
  },
  {
    title: "Voyages événements",
    href: "/themes/voyages-evenements/",
  },
  {
    title: "Voyages en train",
    href: "/themes/voyages-en-train/",
  },
  {
    title: "Noël et Nouvel An",
    href: "/themes/noel-et-nouvel-an/",
  },
  {
    title: "Histoire et actualité",
    href: "/themes/histoire-et-actualite/",
  },
  {
    title: "Cultures et spiritualités",
    href: "/themes/cultures-et-religions/",
  },
  {
    title: "Volcans",
    href: "/themes/volcans/",
  },
];

type Props = {
  catalogueImage: ReactNode;
  menuThemeCards: ReactNode;
};
export const Ideas = ({ catalogueImage, menuThemeCards }: Props) => {
  return (
    <div className="flex gap-6 py-10 container justify-between">
      <div className="flex flex-col gap-1">
        <p className="font-serif text-pr-1 text-base font-medium">Voyages culturels</p>
        {listVoyagesCulturels.map((item) => (
          <ExtendedLink key={item.title} href={item.href}>
            {item.title}
          </ExtendedLink>
        ))}
      </div>
      <div className="flex flex-col gap-1">
        <p className="font-serif text-pr-1 text-base font-medium">Thèmes</p>
        {listThemes.map((item) => (
          <ExtendedLink key={item.title} href={item.href}>
            {item.title}
          </ExtendedLink>
        ))}
      </div>
      <div className="flex flex-col w-64 gap-4">{menuThemeCards}</div>
      <Side catalogueImage={catalogueImage} />
    </div>
  );
};
